import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nontax-diff-tooltip" }
const _hoisted_2 = { key: 1 }


export default /*@__PURE__*/_defineComponent({
  __name: 'NontaxDiffTooltipCell',
  props: {
    text: {},
    tooltip: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (__props.tooltip)
    ? (_openBlock(), _createBlock(_component_v_tooltip, {
        key: 0,
        location: "top",
        "max-width": "520",
        "open-delay": 200,
        "content-class": "nontax-diff-tooltip-wrap"
      }, {
        activator: _withCtx(({ props: tipProps }) => [
          _createElementVNode("span", _mergeProps(tipProps, { class: "diff-tooltip-target" }), _toDisplayString(__props.text), 17)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.tooltip), 1)
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.text), 1))
}
}

})